import { keepPreviousData, useQuery } from '@tanstack/react-query'

import {
  gpuAdminConfigured,
  gpuClient,
  type GpuSchemas,
  unwrapGpu,
} from '@/api/gpu/client'

import { GPU_KEY } from './useGpuAdmin'

export type GpuInstance = GpuSchemas['InstanceView']
export type GpuReport = GpuSchemas['ReportView']

export interface InstanceFilters {
  user_id?: string
  provider?: string
  status?: string
  workload?: string
}

export interface PageQuery {
  page: number
  perPage: number
}

export function useGpuInstances(filters: InstanceFilters, page: PageQuery) {
  return useQuery({
    queryKey: [...GPU_KEY, 'instances', filters, page],
    enabled: gpuAdminConfigured,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      unwrapGpu(
        await gpuClient.GET('/gpu/admin/v1/instances', {
          params: { query: { ...filters, ...page } },
        }),
        'Failed to load GPU instances',
      ),
  })
}

export function useGpuInstance(id: string) {
  return useQuery({
    queryKey: [...GPU_KEY, 'instance', id],
    enabled: gpuAdminConfigured && Boolean(id),
    queryFn: async () =>
      unwrapGpu(
        await gpuClient.GET('/gpu/admin/v1/instances/{id}', {
          params: { path: { id } },
        }),
        'Failed to load GPU instance',
      ),
  })
}

export function useGpuReports(held: boolean, page: PageQuery) {
  return useQuery({
    queryKey: [...GPU_KEY, 'reports', held, page],
    enabled: gpuAdminConfigured,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      unwrapGpu(
        await gpuClient.GET('/gpu/admin/v1/reports', {
          params: { query: { held, ...page } },
        }),
        'Failed to load vodopad reports',
      ),
  })
}
